(function () {
  if (window.__scShippingBoxSyncInit) return;
  window.__scShippingBoxSyncInit = true;

  var INTERNAL_HEADER = 'X-SC-Shipping-Box-Internal';
  var syncing = false;
  var queued = false;
  var queuedCart = null;
  var debounceTimer = null;
  var lastCartSignature = '';

  function normalizeNumber(value) {
    if (typeof value === 'number') return isNaN(value) ? 0 : value;
    var cleaned = String(value == null ? '' : value).replace(/[^\d.-]/g, '').trim();
    if (!cleaned) return 0;
    var parsed = Number(cleaned);
    return isNaN(parsed) ? 0 : parsed;
  }

  function getConfig() {
    var cfg = (window.scCartConfig && window.scCartConfig.shippingBox) || {};
    return {
      productId: normalizeNumber(cfg.productId),
      variantId: normalizeNumber(cfg.variantId),
      gramsPerBox: normalizeNumber(cfg.gramsPerBox) || 8900
    };
  }

  function isCartAjaxUrl(url) {
    if (!url) return false;
    var str = String(url);
    return /\/cart\/(add|change|update|clear)\.js(\?|$)/.test(str);
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('Failed to fetch cart');
      return r.json();
    });
  }

  function getCartSignature(cart) {
    if (!cart || !cart.items) return '';
    return cart.items.map(function (item) {
      return [
        item.key || '',
        normalizeNumber(item.quantity),
        normalizeNumber(item.final_line_price)
      ].join(':');
    }).join('|') + '::' + normalizeNumber(cart.item_count);
  }

  function getRequiredBoxQty(cart, config) {
    if (!cart || !cart.items || !config.productId || !config.gramsPerBox) return 0;

    var totalGrams = 0;
    cart.items.forEach(function (item) {
      if (normalizeNumber(item.product_id) === config.productId) return;
      totalGrams += normalizeNumber(item.grams) * normalizeNumber(item.quantity);
    });

    if (totalGrams <= 0) return 0;
    return Math.ceil(totalGrams / config.gramsPerBox);
  }

  function findShippingBoxItem(cart, config) {
    if (!cart || !cart.items) return null;

    for (var i = 0; i < cart.items.length; i++) {
      if (normalizeNumber(cart.items[i].product_id) === config.productId) {
        return cart.items[i];
      }
    }
    return null;
  }

  function internalFetch(url, options) {
    options = options || {};
    options.credentials = 'same-origin';
    options.headers = options.headers || {};

    if (options.headers instanceof Headers) {
      options.headers.set(INTERNAL_HEADER, '1');
    } else {
      options.headers[INTERNAL_HEADER] = '1';
    }

    return fetch(url, options);
  }

  function updateQtyByVariant(variantId, qty) {
    var updates = {};
    updates[String(variantId)] = qty;

    return internalFetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed /cart/update.js');
      return res.json();
    });
  }

  function addBox(variantId, qty) {
    return internalFetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: qty
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed /cart/add.js');
      return res.json();
    });
  }

  function dispatchCartEvents(cart, variantId, qty) {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:change', {
        detail: { variantId: variantId, quantity: qty, cart: cart }
      }));
      ['cart:updated', 't4s:cart:updated', 'ajaxCart:updated'].forEach(function (name) {
        document.dispatchEvent(new CustomEvent(name, { detail: cart }));
      });
    } catch (e) {}
  }

  function updateCountBadges(cart) {
    var count = normalizeNumber(cart && cart.item_count);

    [
      '[data-cart-count]',
      '[data-cart-items-count]',
      '.t4s-count-box',
      '.js_cart_count',
      '.cart-count-bubble',
      '.site-header__cart-count'
    ].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.textContent = count;
      });
    });

    if (document.documentElement && document.documentElement.className) {
      document.documentElement.className =
        document.documentElement.className.replace(/t4s-cart-count-\d+/g, '').trim() +
        ' t4s-cart-count-' + count;
    }
  }

  function getSectionIdFromElement(el) {
    if (!el || !el.closest) return '';
    var sectionEl = el.closest('[id^="shopify-section-"]');
    if (!sectionEl || !sectionEl.id) return '';
    return sectionEl.id.replace('shopify-section-', '');
  }

  function uniqueStrings(arr) {
    var out = [];
    var seen = {};
    arr.forEach(function (item) {
      if (!item || seen[item]) return;
      seen[item] = true;
      out.push(item);
    });
    return out;
  }

 function collectRefreshSectionIds() {
  var ids = [];

  /*
    Do NOT refresh header sections here.

    Reason:
    shipping-box-sync runs after cart add/update and can auto add/remove the
    Shipping Box line item. If this refresh also replaces the header section,
    the city selector gets rebuilt multiple times and the selected city label
    blinks between "Select" and the saved city.

    Cart counts are already handled by updateCountBadges(cart), so the header
    does not need to be section-refreshed for shipping box changes.
  */
  [
    '#t4s-mini_cart',
    '[data-cart-wrapper]',
    '[data-cart-items]',
    '.t4s-mini_cart',
    '.t4s-drawer__wrap',
    '.t4s-cartPage__form'
  ].forEach(function (selector) {
    document.querySelectorAll(selector).forEach(function (el) {
      var id = getSectionIdFromElement(el);
      if (id) ids.push(id);
    });
  });

  return uniqueStrings(ids);
}

  function replaceSectionHtml(sectionId, html) {
    var current = document.getElementById('shopify-section-' + sectionId);
    if (!current || !html) return;

    var temp = document.createElement('div');
    temp.innerHTML = html;

    var replacement = temp.querySelector('#shopify-section-' + sectionId);
    if (replacement) {
      current.outerHTML = replacement.outerHTML;
    } else {
      current.innerHTML = html;
    }
  }

  /*
  Refresh only cart-related sections.
  Header is intentionally excluded to avoid rebuilding city selector,
  language switcher, search, and header JS after shipping box sync.
*/

  function refreshSectionsInBackground(cart) {
    updateCountBadges(cart);

    var sectionIds = collectRefreshSectionIds();
    if (!sectionIds.length) {
      dispatchCartEvents(cart);
      return Promise.resolve();
    }

    var url = window.location.pathname + '?sections=' + encodeURIComponent(sectionIds.join(','));

    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (sections) {
        sectionIds.forEach(function (id) {
          if (sections && sections[id]) {
            replaceSectionHtml(id, sections[id]);
          }
        });

        updateCountBadges(cart);
        dispatchCartEvents(cart);
      })
      .catch(function (err) {
        console.warn('shipping-box background section refresh failed', err);
        dispatchCartEvents(cart);
      });
  }

  function syncFromCart(cart) {
    var config = getConfig();
    if (!config.productId || !config.variantId) return Promise.resolve();

    if (!cart || !cart.items) {
      return fetchCart().then(syncFromCart);
    }

    if (syncing) {
      queued = true;
      queuedCart = cart;
      return Promise.resolve();
    }

    syncing = true;

    var requiredQty = getRequiredBoxQty(cart, config);
    var boxItem = findShippingBoxItem(cart, config);

    function finish() {
      syncing = false;
      if (queued) {
        queued = false;
        var nextCart = queuedCart;
        queuedCart = null;
        syncFromCart(nextCart);
      }
    }

    // no change needed
    if (!boxItem && requiredQty <= 0) {
      lastCartSignature = getCartSignature(cart);
      finish();
      return Promise.resolve();
    }

    // add new bag line
    if (!boxItem && requiredQty > 0) {
      return addBox(config.variantId, requiredQty)
        .then(function () {
          return fetchCart();
        })
        .then(function (updatedCart) {
          lastCartSignature = getCartSignature(updatedCart);
          return refreshSectionsInBackground(updatedCart);
        })
        .catch(function (err) {
          console.warn('shipping box add failed', err);
        })
        .finally(finish);
    }

    // remove bag line
    if (boxItem && requiredQty <= 0) {
      return updateQtyByVariant(boxItem.variant_id, 0)
        .then(function () {
          return fetchCart();
        })
        .then(function (updatedCart) {
          lastCartSignature = getCartSignature(updatedCart);
          return refreshSectionsInBackground(updatedCart);
        })
        .catch(function (err) {
          console.warn('shipping box remove failed', err);
        })
        .finally(finish);
    }

    // quantity-only change
    if (boxItem && normalizeNumber(boxItem.quantity) !== requiredQty) {
      return updateQtyByVariant(boxItem.variant_id, requiredQty)
        .then(function (updatedCart) {
          lastCartSignature = getCartSignature(updatedCart);
          return refreshSectionsInBackground(updatedCart);
        })
        .catch(function (err) {
          console.warn('shipping box qty update failed', err);
        })
        .finally(finish);
    }

    lastCartSignature = getCartSignature(cart);
    finish();
    return Promise.resolve();
  }

  function queueSync(cart, delay) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      syncFromCart(cart || null);
    }, typeof delay === 'number' ? delay : 180);
  }

  // Primary hook: your custom mini-ATC / update path
  ['cart:updated', 't4s:cart:updated', 'ajaxCart:updated'].forEach(function (eventName) {
    document.addEventListener(eventName, function (e) {
      var cart = e && e.detail && e.detail.items ? e.detail : null;
      queueSync(cart, 120);
    });
  });

  // Fallback: any Kalles/homepage Shopify cart AJAX
  (function patchFetch() {
    if (!window.fetch || window.__scShippingBoxFetchPatched) return;
    window.__scShippingBoxFetchPatched = true;

    var originalFetch = window.fetch;

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isInternal = false;

      try {
        var headers = init && init.headers;
        if (headers instanceof Headers) {
          isInternal = headers.get(INTERNAL_HEADER) === '1';
        } else if (headers) {
          isInternal = headers[INTERNAL_HEADER] === '1' || headers[INTERNAL_HEADER.toLowerCase()] === '1';
        }
      } catch (e) {}

      var promise = originalFetch.apply(this, arguments);

      if (!isInternal && isCartAjaxUrl(url)) {
        promise.then(function () {
          fetchCart().then(function (cart) {
            var signature = getCartSignature(cart);
            if (signature !== lastCartSignature) {
              queueSync(cart, 180);
            }
          }).catch(function () {});
        }).catch(function () {});
      }

      return promise;
    };
  })();

  (function patchXHR() {
    if (!window.XMLHttpRequest || window.__scShippingBoxXHRPatched) return;
    window.__scShippingBoxXHRPatched = true;

    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;
    var originalSetRequestHeader = XMLHttpRequest.prototype.setRequestHeader;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__scCartUrl = url || '';
      this.__scInternal = false;
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.setRequestHeader = function (name, value) {
      if (String(name).toLowerCase() === INTERNAL_HEADER.toLowerCase()) {
        this.__scInternal = String(value) === '1';
      }
      return originalSetRequestHeader.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      this.addEventListener('loadend', function () {
        if (!this.__scInternal && isCartAjaxUrl(this.__scCartUrl)) {
          fetchCart().then(function (cart) {
            var signature = getCartSignature(cart);
            if (signature !== lastCartSignature) {
              queueSync(cart, 180);
            }
          }).catch(function () {});
        }
      });
      return originalSend.apply(this, arguments);
    };
  })();

  // Initial load
  fetchCart()
    .then(function (cart) {
      lastCartSignature = getCartSignature(cart);
      return syncFromCart(cart);
    })
    .catch(function (err) {
      console.warn('shipping box initial sync failed', err);
    });
})();